var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"songs-player-poster-box"},[_c('v-img',{staticClass:"poster",attrs:{"path":_vm.poster}}),_c('div',{staticClass:"song-title",domProps:{"innerHTML":_vm._s(_vm.title)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }